 
export class ApiAuthStrategies {
  static getBearerTokenHeader (): string {
    const token: string | null = localStorage.getItem('access-token')
    return `Bearer ${token}`
  }
}
